import { useUser } from './useUser';
import { useAccountStore } from '../components/Stores/accountStore';

/**
 * Hook to check if current user has admin access
 * 
 * Returns true if:
 * 1. User is a superadmin (global access), OR
 * 2. User has 'admin' role in the currently active account
 * 
 * This properly handles account switching - when admin switches accounts,
 * their admin status is checked against the new active account.
 */
export const useIsAdmin = (): boolean => {
  const { data: user } = useUser();
  const { account } = useAccountStore();

  if (!user) return false;

  // Superadmins always have admin access
  if (user.isAdmin) return true;

  // Check if user has admin role in the active account
  // Note: user.accountId is set to first account on login, but active account
  // is tracked separately in accountStore (especially for account switching)
  const activeAccountId = account?.id;
  if (!activeAccountId) return false;

  // Parse user data from sessionStorage to get all accounts with roles
  try {
    const userStr = sessionStorage.getItem('user');
    if (!userStr) return false;

    const userData = JSON.parse(userStr);
    const activeAccountData = userData.accounts?.find(
      (acc: any) => acc.accountId === activeAccountId
    );

    return activeAccountData?.role === 'admin';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};
